import { computed } from 'vue';

/**
 * Consulta externa do Informe de Rendimentos (IRPF), compartilhada entre a
 * página antiga (pages/user/irpf-rendimentos.vue) e a tela nova do Minha
 * Conta V2 (components/user-v2/ScreenIncomeReport.vue): monta a URL do
 * portal com CPF + data de nascimento e abre em nova aba.
 */
export function useIrpfReport() {
  const { userDocument, userBirthdate } = useUserData();

  const IRPF_BASE_URL = 'https://irpf.blowbet.com.br/';
  const BRAND_ID = 'AT';
  // ano-base do informe (declaração do ano corrente cobre o ano anterior)
  const reportYear = String(new Date().getFullYear() - 1);

  const hasValidBirthdate = computed(() => {
    return !!userBirthdate.value && userBirthdate.value !== '0000-00-00';
  });

  const hasRequiredData = computed(() => {
    return !!userDocument.value && hasValidBirthdate.value;
  });

  const irpfUrl = computed(() => {
    if (!hasRequiredData.value) return '';

    const params = new URLSearchParams({
      brand_id: BRAND_ID,
      client_id: userDocument.value,
      birth_date: userBirthdate.value,
    });

    return `${IRPF_BASE_URL}?${params.toString()}`;
  });

  function handleDownload() {
    if (!hasRequiredData.value || !irpfUrl.value) return;
    window.open(irpfUrl.value, '_blank');
  }

  return { reportYear, hasRequiredData, irpfUrl, handleDownload };
}
